<template>
  <div class="newOneNews" @click="openDetails(onenews.new_id)">
    <div class="img">
      <img :src="imageLink(onenews.new_image)" />
    </div>
    <div class="data-news">
      <h2>{{ onenews.new_title }}</h2>
      <p class="newsdate">
        <img src="@/assets/newImges/calendar-solid.svg" alt="" srcset="" />{{
          onenews.new_date
        }}
      </p>
      <!-- <div
        v-if="onenews.new_article"
        class="description"
        v-html="this.description() + '...'"
      ></div> -->
      <p class="autor">@ {{ onenews.new_author }}</p>
    </div>
  </div>
</template>

<script>
import { baseURL } from "@/api";

export default {
  name: "OneNews",
  props: {
    onenews: {
      required: true,
      type: Object
    }
  },
  methods: {
    imageLink(image) {
      return baseURL + image;
    },
    openDetails(id) {
      let params = Object.assign({}, this.$route.params);
      params.id = id;
      this.$router.push({ name: "NewsDescriptionPage", params: params });
    }
  }
};
</script>

<style lang="scss" scoped>
.newOneNews {
  text-align: left;
  width: 638px;
  max-width: calc(50% - 25px);
  cursor: pointer;
  width: 638.09521484375;
  min-height: 521;
  border-radius: 12px;
  gap: 69px;
  border: 1px solid $gray-blue-600;
  background-color: $gray-blue-100;
  font-family: Outfit;

  .img {
    /* width: 25%; */
    width: 100%;
    height: 265px;
    display: block;
    position: relative;
    overflow: hidden;
    margin-bottom: 36px;
    border-radius: 12px 12px 0 0;

    img {
      /*  position: absolute;
        top: 0;
        left: 0;
        width: 100%;
  */
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .data-news {
    box-sizing: border-box;
    padding: 0 49px 49px 49px;
  }

  h2 {
    font-weight: 400;
    font-style: Regular;
    font-size: 26px;
    line-height: 34px;
    letter-spacing: 0%;

    color: $blue-1000;
  }

  .newsdate {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;

    color: $blue-400;
    display: flex;
    align-items: center;
    img {
      margin-right: 17px;
    }
  }
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.02em;
    color: $blue-400;
  }

  .autor {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;

    color: $light-blue-600;
  }
}
@media only screen and (max-width: 768px) {
  .newOneNews {
    .img {
      margin-bottom: 20px;
    }
    .data-news {
      box-sizing: border-box;
      padding: 0 20px 10px 20px;
      h2 {
        font-size: 20px;
        line-height: 28px;
      }
      .newsdate {
        font-size: 14px;
        line-height: 22px;
        img {
          //   width: 15px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
